var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2328_18401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33398C5.41967 1.33398 3.33301 3.42065 3.33301 6.00065C3.33301 7.16065 3.66634 8.24732 4.27301 9.22732C4.90634 10.254 5.73967 11.134 6.37967 12.1607C6.69301 12.6607 6.91967 13.1273 7.15967 13.6673C7.33301 14.034 7.47301 14.6673 7.99967 14.6673C8.52634 14.6673 8.66634 14.034 8.83301 13.6673C9.07967 13.1273 9.29967 12.6607 9.61301 12.1607C10.253 11.1407 11.0863 10.2607 11.7197 9.22732C12.333 8.24732 12.6663 7.16065 12.6663 6.00065C12.6663 3.42065 10.5797 1.33398 7.99967 1.33398ZM7.99967 7.83398C7.07967 7.83398 6.33301 7.08732 6.33301 6.16732C6.33301 5.24732 7.07967 4.50065 7.99967 4.50065C8.91967 4.50065 9.66634 5.24732 9.66634 6.16732C9.66634 7.08732 8.91967 7.83398 7.99967 7.83398Z",
    fill: "#F77A6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2328_18401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location-pin-icon.b584c08ab094012eb85f6a11649b548b.svg";
export { ForwardRef as ReactComponent };